import styled, { css } from 'styled-components'
import { Modal } from 'src/components'

export const CustomModal = styled(Modal)<{ $maxWidth: string }>`
  ${({ $maxWidth }) =>
    $maxWidth
      ? css`
          --modal-max-width: ${$maxWidth};
        `
      : ''}
`

CustomModal.displayName = 'CustomModal'
